export { Tooltip } from './Tooltip';
export type { TooltipProps } from './Tooltip';

export { useToolTip } from './useToolTip';
export type { TooltipConfigProps } from './useToolTip';
